import { ProjectsService } from '@core/services/projects/projects.service';
import { UserService } from '@core/services/user/user.service';
import { Inject, Injectable } from '@rxdi/core';
import { CanActivateCommands, CanActivateContext, CanActivateResolver } from '@rxdi/router';
import { SocialService } from '@stradivario/graphql-server';
import { map } from 'rxjs/operators';

@Injectable()
export class LoggedInGuard implements CanActivateResolver {
  @Inject(SocialService)
  private socialService: SocialService;

  canActivate(context: CanActivateContext, commands: CanActivateCommands) {
    return this.socialService.checkLoggedIn().pipe(
      map((e) => {
        if (!e) {
          return commands.redirect('/unauthorized');
        }
        return true;
      })
    ) as never;
  }
}

@Injectable()
export class ProjectGuard implements CanActivateResolver {
  @Inject(ProjectsService) private projectsService: ProjectsService;

  canActivate(context: CanActivateContext, commands: CanActivateCommands) {
    const params: { id: string } = context['params'] || {};

    return this.projectsService.getProject(params).pipe(
      map((p) => {
        if (!p) {
          return commands.redirect('/projects');
        }
        return true;
      })
    ) as never;
  }
}

@Injectable()
export class IsAdminGuard implements CanActivateResolver {
  @Inject(UserService) private userService: UserService;

  canActivate(context: CanActivateContext, commands: CanActivateCommands) {
    return this.userService.canViewProfileSession().pipe(
      map((p) => {
        if (!p) {
          return commands.redirect('/');
        }
        return true;
      })
    ) as never;
  }
}
